/**
 * @generated SignedSource<<4e5c2310612c7b06e865a080fdeaab8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BasisEnum = "CASH" | "NORMALIZED" | "%future added value";
export type pnlPage_Query$variables = {
  basis?: BasisEnum | null | undefined;
  perspectiveId?: string | null | undefined;
};
export type pnlPage_Query$data = {
  readonly allStakeholders: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly bankAccounts: ReadonlyArray<{
    readonly id: string;
    readonly last4: string | null | undefined;
    readonly name: string;
    readonly nickname: string;
    readonly number: string;
  }>;
  readonly execComp: {
    readonly adjustedEbitda: number;
    readonly adjustedEbitdaMargin: number | null | undefined;
    readonly byStakeholder: ReadonlyArray<{
      readonly category: string;
      readonly name: string;
      readonly ttm: number;
    }>;
    readonly monthlyTotal: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly ttmDistributions: number;
    readonly ttmEbitda: number;
    readonly ttmExecComp: number;
  };
  readonly pnl: {
    readonly afterDistributions: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly cac: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly cacTtm: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly categories: ReadonlyArray<{
      readonly category: {
        readonly id: string;
      } | null | undefined;
      readonly monthly: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
      readonly name: string;
      readonly pnlLine: string;
    }>;
    readonly cogs: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly distributions: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly ebitda: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly gAndA: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly grossProfit: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly interestAndFees: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly loanPrincipalRepaid: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly loanProceeds: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly rAndD: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly revenue: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly sAndM: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly taxes: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly uncategorized: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
  };
};
export type pnlPage_Query = {
  response: pnlPage_Query$data;
  variables: pnlPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "basis"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v2 = {
  "kind": "Variable",
  "name": "perspectiveId",
  "variableName": "perspectiveId"
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ttmExecComp",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ttmDistributions",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ttmEbitda",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "adjustedEbitda",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "adjustedEbitdaMargin",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v11 = [
  (v9/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ttm",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "bankAccounts",
  "plural": true,
  "selections": [
    (v15/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nickname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last4",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "allStakeholders",
  "plural": true,
  "selections": [
    (v15/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v18 = [
  {
    "kind": "Variable",
    "name": "basis",
    "variableName": "basis"
  },
  (v2/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pnlLine",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": [
    (v15/*: any*/)
  ],
  "storageKey": null
},
v21 = [
  (v9/*: any*/),
  (v10/*: any*/),
  (v15/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "pnlPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ExecComp",
        "kind": "LinkedField",
        "name": "execComp",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "monthlyTotal",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ExecCompStakeholder",
            "kind": "LinkedField",
            "name": "byStakeholder",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v16/*: any*/),
      (v17/*: any*/),
      {
        "alias": null,
        "args": (v18/*: any*/),
        "concreteType": "Pnl",
        "kind": "LinkedField",
        "name": "pnl",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "revenue",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "cogs",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "grossProfit",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "sAndM",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "rAndD",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "gAndA",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "uncategorized",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "ebitda",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "taxes",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "distributions",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "afterDistributions",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "interestAndFees",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "loanProceeds",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "loanPrincipalRepaid",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PnlCategory",
            "kind": "LinkedField",
            "name": "categories",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "monthly",
                "plural": true,
                "selections": (v11/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "cac",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "cacTtm",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "pnlPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ExecComp",
        "kind": "LinkedField",
        "name": "execComp",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "monthlyTotal",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ExecCompStakeholder",
            "kind": "LinkedField",
            "name": "byStakeholder",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      (v16/*: any*/),
      (v17/*: any*/),
      {
        "alias": null,
        "args": (v18/*: any*/),
        "concreteType": "Pnl",
        "kind": "LinkedField",
        "name": "pnl",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "revenue",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "cogs",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "grossProfit",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "sAndM",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "rAndD",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "gAndA",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "uncategorized",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "ebitda",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "taxes",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "distributions",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "afterDistributions",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "interestAndFees",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "loanProceeds",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "loanPrincipalRepaid",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PnlCategory",
            "kind": "LinkedField",
            "name": "categories",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "monthly",
                "plural": true,
                "selections": (v21/*: any*/),
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "cac",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "cacTtm",
            "plural": true,
            "selections": (v21/*: any*/),
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "99473ee649642f30039a3dfc7246f803",
    "id": null,
    "metadata": {},
    "name": "pnlPage_Query",
    "operationKind": "query",
    "text": "query pnlPage_Query(\n  $perspectiveId: ID\n  $basis: BasisEnum\n) {\n  execComp(perspectiveId: $perspectiveId) {\n    ttmExecComp\n    ttmDistributions\n    ttmEbitda\n    adjustedEbitda\n    adjustedEbitdaMargin\n    monthlyTotal {\n      month\n      value\n      id\n    }\n    byStakeholder {\n      name\n      category\n      ttm\n      id\n    }\n    id\n  }\n  bankAccounts {\n    id\n    name\n    nickname\n    last4\n    number\n  }\n  allStakeholders {\n    id\n    name\n  }\n  pnl(perspectiveId: $perspectiveId, basis: $basis) {\n    revenue {\n      month\n      value\n      id\n    }\n    cogs {\n      month\n      value\n      id\n    }\n    grossProfit {\n      month\n      value\n      id\n    }\n    sAndM {\n      month\n      value\n      id\n    }\n    rAndD {\n      month\n      value\n      id\n    }\n    gAndA {\n      month\n      value\n      id\n    }\n    uncategorized {\n      month\n      value\n      id\n    }\n    ebitda {\n      month\n      value\n      id\n    }\n    taxes {\n      month\n      value\n      id\n    }\n    distributions {\n      month\n      value\n      id\n    }\n    afterDistributions {\n      month\n      value\n      id\n    }\n    interestAndFees {\n      month\n      value\n      id\n    }\n    loanProceeds {\n      month\n      value\n      id\n    }\n    loanPrincipalRepaid {\n      month\n      value\n      id\n    }\n    categories {\n      name\n      pnlLine\n      category {\n        id\n      }\n      monthly {\n        month\n        value\n        id\n      }\n      id\n    }\n    cac {\n      month\n      value\n      id\n    }\n    cacTtm {\n      month\n      value\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f83d4558c4f3b7b51218c6744ed31676";

export default node;
